import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _763f25d3 = () => interopDefault(import('../pages/error/index.vue' /* webpackChunkName: "pages/error/index" */))
const _9c5d8fae = () => interopDefault(import('../pages/sign-out/index.vue' /* webpackChunkName: "pages/sign-out/index" */))
const _f5b43c5a = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _52c4458e = () => interopDefault(import('../pages/users/create/index.vue' /* webpackChunkName: "pages/users/create/index" */))
const _1d137339 = () => interopDefault(import('../pages/users/_username/index.vue' /* webpackChunkName: "pages/users/_username/index" */))
const _13aa3d1a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2fc75e27 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _763f25d3,
    name: "error"
  }, {
    path: "/sign-out",
    component: _9c5d8fae,
    name: "sign-out"
  }, {
    path: "/users",
    component: _f5b43c5a,
    name: "users"
  }, {
    path: "/users/create",
    component: _52c4458e,
    name: "users-create"
  }, {
    path: "/users/:username",
    component: _1d137339,
    name: "users-username"
  }, {
    path: "/",
    component: _13aa3d1a,
    name: "index"
  }, {
    path: "/*",
    component: _2fc75e27,
    name: "all"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
